export const initModalSize = (container) => {
	if (!container) return;

	setTimeout(() => {
		container.style.display = 'block';
	}, 2000);

	const closeButtons = document.querySelectorAll('.js-modal-size-close');

	closeButtons.forEach((clsBtn) => {
		clsBtn.addEventListener('click', () => {
			container.classList.remove('active');
		});
	});
};
